import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import { mapState, mapActions } from 'vuex'
import constants from '@/util/constants'
import util from '@/util'
import mensagens from '@/util/mensagens'

export default {
  name: 'cliente',
  components: {
    'default-table': defaultTable
  },

  computed: {
    ...mapState('usuarios', ['listaEstadosDisponiveis', 'dadosPerfil', 'dadosRetorno', 'flagsDeControle']),
    estaRealizandoProcessamento () {
      return this.flagsDeControle.manipulandoDados.status || this.flagsDeControle.carregandoDados.status
    }
  },

  data: () => {
    return {
      timeOutDigitacaoNocombo: null,
      comboClientesDisponiveis: [],
      comboTiposPrazosDisponiveis: [],
      clienteSelecionado: null,
      tipoPrazoSelecionado: null,
      comboEstadosDisponiveis: [],
      estadoSelecionado: null,
      comboAreasDisponiveis: [],
      areaSelecionada: null,
      fieldsPermissoes: [
        { key: 'f_client_name', sortable: false, label: 'Cliente' },
        { key: 'f_state_name', sortable: false, label: 'Estado' },
        { key: 'f_area_name', sortable: false, label: 'Área' },
        { key: 'opcoes', sortable: false, label: 'Opções' }
      ],
      fieldsTiposPrazo: [
        { key: 'f_name', sortable: false, label: 'Tipo de Prazo' },
        { key: 'f_area_name', sortable: false, label: 'Área' },
        { key: 'opcoes', sortable: false, label: 'Opções' }
      ],
      idOpcaoComboPrazos: null
    }
  },

  mounted () {
    this.limparListaErros()
    this.obterClientesDisponiveis()
    this.obterEstadosDisponiveis()
    this.obterAreasDisponiveis()
    this.obterTiposPrazosDisponiveis()
  },

  methods: {
    ...mapActions('usuarios', ['ActionDefinirListaEstados']),

    tabelaSemRegistros (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center'
      }
    },

    eventoDigitarBuscaPorCliente (valorDigitadoParaBusca, callbackFlagCarregamento) {
      this.limparListaErros()

      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterClientesDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterClientesDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }

      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }

      const resposta = await this.axios.post('/clientes', parametrosRequisicao)
      let listaClientes = resposta.data.retorno.dados
      this.comboClientesDisponiveis = []
      for (let indice in listaClientes) {
        let cliente = listaClientes[indice]
        this.comboClientesDisponiveis.push({ label: cliente.f_name, code: cliente.f_id })
      }
      callbackFlagCarregamento = false
    },

    eventoDigitarBuscaPorEstado (valorDigitadoParaBusca, callbackFlagCarregamento) {
      this.limparListaErros()

      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterEstadosDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterEstadosDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }

      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }

      await this.ActionDefinirListaEstados(parametrosRequisicao)
      this.comboEstadosDisponiveis = this.listaEstadosDisponiveis.map(function (registro) {
        return { label: registro.f_name, code: registro.f_id }
      })
      callbackFlagCarregamento = false
    },

    eventoDigitarBuscaPorArea (valorDigitadoParaBusca, callbackFlagCarregamento) {
      this.limparListaErros()

      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterAreasDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterAreasDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }

      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }
      const resposta = await this.axios.post('/areas', parametrosRequisicao)
      let listaAreas = resposta.data.retorno.dados
      this.comboAreasDisponiveis = []
      for (let idArea in listaAreas) {
        let area = listaAreas[idArea]
        this.comboAreasDisponiveis.push({ label: area.f_name, code: area.f_id })
      }
      callbackFlagCarregamento = false
    },

    adicionarNaLista () {
      this.limparListaErros()
      let listaClientes = this.dadosPerfil.f_profiles_clients

      let clienteInformado = false
      let estadoInformado = false
      let areaInformada = false

      let clienteJaExistente = false
      let estadoJaExistente = false
      let areaJaExistente = false

      if (!util.valorEhNulo(this.clienteSelecionado)) {
        clienteInformado = true
        if (!util.valorVazio(listaClientes)) {
          clienteJaExistente = listaClientes.some((cliente) => cliente.f_client === this.clienteSelecionado.code)
        }
      } else {
        this.dadosRetorno.listaDeErros['f_profile_data.f_profiles_clients'] = 'Selecione um cliente'
      }

      if (!util.valorEhNulo(this.estadoSelecionado)) {
        estadoInformado = true
        if (!util.valorVazio(listaClientes)) {
          estadoJaExistente = listaClientes.some((estado) => estado.f_state === this.estadoSelecionado.code)
        }
      } else {
        this.dadosRetorno.listaDeErros['f_profiles_clients.f_state_name'] = 'Selecione um estado'
      }

      if (!util.valorEhNulo(this.areaSelecionada)) {
        areaInformada = true
        if (!util.valorVazio(listaClientes)) {
          areaJaExistente = listaClientes.some((area) => area.f_area === this.areaSelecionada.code)
        }
      } else {
        this.dadosRetorno.listaDeErros['f_profiles_clients.f_area_name'] = 'Selecione uma área'
      }
      let clienteId = this.clienteSelecionado.code
      let estadoId = this.estadoSelecionado.code
      let areaId = this.areaSelecionada.code

      for (let i = 0; i < listaClientes.length; i++) {
        if (listaClientes[i].f_client === clienteId) {
          clienteJaExistente = true
          if (listaClientes[i].f_state === estadoId) {
            estadoJaExistente = true
            if (listaClientes[i].f_area !== areaId) {
              areaJaExistente = false
            } else {
              areaJaExistente = true
            }
          } else {
            estadoJaExistente = false
          }
        } else {
          clienteJaExistente = false
        }
        if (clienteJaExistente && estadoJaExistente && areaJaExistente) {
          break
        }
      }

      let todosDadosInformados = (clienteInformado && estadoInformado && areaInformada)
      let todosDadosJaExistentes = (clienteJaExistente && estadoJaExistente && areaJaExistente)

      if (todosDadosInformados) {
        if (todosDadosJaExistentes) {
          this.dadosRetorno.listaDeErros['f_profiles_clients.f_cliente_name'] = 'O usuário já tem esta permissão'
          this.dadosRetorno.listaDeErros['f_profiles_clients.f_state_name'] = 'O usuário já tem esta permissão'
          this.dadosRetorno.listaDeErros['f_profiles_clients.f_area_name'] = 'O usuário já tem esta permissão'
        } else {
          const obj = {
            'f_client_name': this.clienteSelecionado.label,
            'f_client': this.clienteSelecionado.code,
            'f_state_name': this.estadoSelecionado.label,
            'f_state': this.estadoSelecionado.code,
            'f_area_name': this.areaSelecionada.label,
            'f_area': this.areaSelecionada.code
          }
          this.dadosPerfil.f_profiles_clients.push(obj)
          this.resetarAutoComplete()
        }
      }
    },

    excluirDaLista (item) {
      const indice = this.dadosPerfil.f_profiles_clients.map(
        function (elemento) {
          return elemento.f_id
        }).indexOf(item.f_id)
      if (indice !== -1) {
        this.dadosPerfil.f_profiles_clients.splice(indice, 1)
      }
    },

    selecionarOpcaoComboAcoes (nodo) {
      this.tipoPrazoSelecionado = nodo
    },

    async obterTiposPrazosDisponiveis (valorDigitadoParaBusca) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      const parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }

      const resposta = await this.axios.post('/areas/prazos', parametrosRequisicao)
      const listaPrazos = resposta.data.retorno.dados
      const comboTiposPrazos = listaPrazos.map(({ f_id: id, f_name: nome, f_appointment_types: prazos }) => ({
        label: nome,
        id: nome,
        children: prazos.map(({ f_id: idPrazo, f_name: nomePrazo }) => ({
          label: nomePrazo,
          id: idPrazo,
          idArea: id,
          labelArea: nome
        }))
      }))
      this.comboTiposPrazosDisponiveis = comboTiposPrazos
      this.definirFlagCarregandoDados(false, '')
    },

    validarListagemPrazos (tipoPrazoSelecionado) {
      const prazoNaoInformado = util.valorEhNulo(tipoPrazoSelecionado) || util.valorEhNulo(this.idOpcaoComboPrazos)
      if (prazoNaoInformado) {
        this.dadosRetorno.listaDeErros['f_profile_data.f_appointment_types'] = 'Selecione um tipo de prazo'
        return true
      }
      const listaTiposPrazos = this.dadosPerfil.f_appointment_types
      const prazoJaExistente = listaTiposPrazos.some((prazo) => prazo.f_id === tipoPrazoSelecionado.id)

      if (prazoJaExistente) {
        this.dadosRetorno.listaDeErros['f_profile_data.f_appointment_types'] = 'O usuário já tem essa regra'
      }
      const possuiErros = prazoJaExistente
      return possuiErros
    },

    adicionarNaListaPrazos (tipoPrazoSelecionado) {
      this.limparListaErros()
      const possuiErros = this.validarListagemPrazos(tipoPrazoSelecionado)
      if (!possuiErros) {
        this.dadosPerfil.f_appointment_types.push({
          'f_area': tipoPrazoSelecionado.idArea,
          'f_area_name': tipoPrazoSelecionado.labelArea,
          'f_id': tipoPrazoSelecionado.id,
          'f_name': tipoPrazoSelecionado.label
        })
      }
      this.resetarAutoComplete()
    },

    removerTipoPrazo (tipoPrazoSelecionado) {
      this.dadosPerfil.f_appointment_types = this.dadosPerfil.f_appointment_types.filter(prazo => prazo.f_id !== tipoPrazoSelecionado.f_id)
    },

    resetarAutoComplete () {
      this.clienteSelecionado = null
      this.estadoSelecionado = null
      this.areaSelecionada = null
      this.tipoPrazoSelecionado = null
      this.idOpcaoComboPrazos = null
    },

    limparListaErros () {
      this.dadosRetorno.listaDeErros = {}
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    }
  }
}
